export interface UserRolesModelApiResponse {
    createOrder: string;
    createUser: string;
    deleteOrder: string;
    deleteUser: string;
    disableUser: string;
    enableUser: string;
    id: number;
    name: string;
    platformType: string;
    readOnly: string;
    sendOrder: string;
}
export interface UserRolesModel {
    createOrder: string;
    createUser: string;
    deleteOrder: string;
    deleteUser: string;
    disableUser: string;
    enableUser: string;
    id: number;
    name: string;
    platformType: string;
    readOnly: string;
    sendOrder: string;
}
export class UserRoles implements UserRolesModel {
    createOrder = '';
    createUser = '';
    deleteOrder = '';
    deleteUser = '';
    disableUser = '';
    enableUser = '';
    id = -1;
    name = '';
    platformType = '';
    readOnly = '';
    sendOrder = '';

    constructor(dto?: UserRolesModel) {
        if (!dto) {
            return;
        }
        this.createOrder = dto.createOrder;
        this.createUser = dto.createUser;
        this.deleteOrder = dto.deleteOrder;
        this.deleteUser = dto.deleteUser;
        this.disableUser = dto.disableUser;
        this.enableUser = dto.enableUser;
        this.id = dto.id;
        this.name = dto.name;
        this.platformType = dto.platformType;
        this.readOnly = dto.readOnly;
        this.sendOrder = dto.sendOrder;
    }
}